import { HttpErrorResponse } from '@angular/common/http';
import { extractErrorMessage } from '../../../../../../core/utils/extract-error-message.util';
import { Component, EventEmitter, NgZone, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { Subject, Subscription, debounceTime, finalize } from 'rxjs';
import Swal from 'sweetalert2';
import {
  ACTION_SOCKET,
  CONFIG_BASE_DATE_RANGEPICKER,
  COUNTRY_CODES_DEFAULT,
  DEFAULT_DATETIME_FORMATS,
  FILTER_DATETIME_FORMAT,
} from '../../../../../../core/constants/constants';
import { itemUpdateCw } from '../../../../../../core/interfaces/subscription-payment.interface';
import {
  ChargesWithdrawalsRequestCounts,
  ChargesWithdrawalsRequestItem,
  ChargesWithdrawalsRequestListData,
  CwOperatorInfo,
} from '../../../../../../core/interfaces/charges-withdrawals-request.interface';
import { BotLock } from '../../../../../../core/interfaces/bot-withdrawal.interface';
import { ChargesWithdrawalsRequestService } from '../../../../../../core/services/charges-withdrawals-request.service';
import { DynamicModalService } from '../../../../../../core/services/dynamic-modal.service';
import { FilterCommunicationService } from '../../../../../../core/services/filter-communication.service';
import { BotWithdrawalService } from '../../../../../../core/services/bot-withdrawal.service';
import { SocketService } from '../../../../../../core/services/socket.service';
import { UserService } from '../../../../../../core/services/user.service';
import { selectAuth } from '../../../../../../core/state/auth/auth.selector';
import { selectScreen } from '../../../../../../core/state/screen/screen.selectors';
import { formatAmount } from '../../../../../../core/utils/format-numeric.utils';
import {
  MAIN_PERMISSIONS,
  ROLES,
} from '../../../../../../shared/data/config/constants';
import {
  REQUEST_STATUS,
  REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS,
  REQUEST_WITHDRAWAL_PERMISSIONS,
  STATE_PERMISSION_MAP,
} from '../../../../../../shared/data/config/constants-buttons';
import {
  COUNTRIES,
  CREATED_BY_AGENT,
  CURRENCY_VALUES,
  DATE_TEXT,
  DEFAULT_CW_COUNTRY_ID,
  DEFAULT_PROCESSED_QUEUE_MINUTES,
  DEFAULT_VALUE,
  IS_CROSS_REQUEST,
  ORIGIN,
  STATE_CLASSES,
  STATE_NAMES,
  TRANSACTION_CLASSES,
  TRANSACTION_ICON_CLASSES,
  TRANSACTION_TYPES,
  TRANSACTION_TYPE_VALUES,
  columnsTable,
  headersExcel,
} from '../../../../../../shared/data/suscriptions-payments/constants';
import { AlertService } from '../../../../../../shared/services/alert.service';
import { ExcelExportService } from '../../../../../../shared/services/excel-export.service';
import { CreateCwRequestComponent } from '../forms/create-cw-request/create-cw-request.component';
import { DivideCwRequestComponent } from '../forms/divide-cw-request/divide-cw-request.component';
import { EditCwRequestComponent } from '../forms/edit-cw-request/edit-cw-request.component';
import { ReverseCwRequestComponent } from '../forms/reverse-cw-request/reverse-cw-request.component';
import { ViewPayOutDetailComponent } from '../forms/view-pay-out-detail/view-pay-out-detail.component';
import { ViewPayComponent } from '../forms/view-pay/view-pay.component';
import { ImageViewComponent } from '../image-view/image-view.component';
import { environment } from '../../../../../../../environments/environment';
import { TransactionTypeSelectorComponent } from '../transaction-type-selector/transaction-type-selector.component';
import { AuthActions } from '../../../../../../core/state/auth/auth.actions';
import { TotalCountResponse } from '../../../../../../core/interfaces/ui/total-count-versions.interface';
import { RepeatedVoucherActionModalComponent } from '../forms/repeated-voucher-action-modal/repeated-voucher-action-modal.component';
import { RepeatedCwVouchersModalComponent } from '../forms/repeated-cw-vouchers-modal/repeated-cw-vouchers-modal.component';
import { User } from '../../../../../../core/interfaces/user.interface';
import { SupportModeService } from '../../../../../../core/services/ui/support-mode.service';
import { SUPPORT_ID_COLUMN_NAME } from '../../../../../../core/constants/support-mode.constant';
(pdfMake as any).vfs = pdfFonts.pdfMake.vfs;

type OperatorInfoView = { initials: string; name: string; isActive: boolean };

interface CwActionButton {
  tooltip: string;
  icon: string;
  btnClass: string;
  action: () => void;
  item?: FormattedCwItem;
}

type FormattedCwItem = Omit<ChargesWithdrawalsRequestItem, 'monto'> & {
  monto: string;
  updated_by_initials: string;
  formatted_name: string;
  formatted_holder_name: string;
  operators: {
    pagos: OperatorInfoView | null;
    atc: OperatorInfoView | null;
    other: OperatorInfoView | null;
  };
};

@Component({
  selector: 'app-cw-table',
  templateUrl: './cw-table.component.html',
  styleUrl: './cw-table.component.scss',
})
export class CwTableComponent implements OnInit {
  private readonly DUPLICATE_VOUCHER_REJECT_REASON =
    'Solicitud rechazada por comprobante repetido';
  private readonly repeatedVouchersModalTitle = 'Comprobantes repetidos';
  @Output() totalPendingChange: EventEmitter<number> =
    new EventEmitter<number>();
  @Output() totalEnRevisionChange: EventEmitter<number> =
    new EventEmitter<number>();
  @Output() totalProcessedChange: EventEmitter<number> =
    new EventEmitter<number>();
  @Output() totalChargeNotIncomeChange: EventEmitter<number> =
    new EventEmitter<number>();
  @Output() totalBotProblemChange: EventEmitter<number> =
    new EventEmitter<number>();
  @Output() totalCorrectionChange: EventEmitter<number> =
    new EventEmitter<number>();
  @Output() totalReverseChange: EventEmitter<number> =
    new EventEmitter<number>();
  @Output() totalCountChange: EventEmitter<number> = new EventEmitter<number>();
  @Output() loading: EventEmitter<boolean> = new EventEmitter<boolean>();
  public columnsTable = columnsTable;
  public isSupportMode: boolean = false;
  public supportRequestId = '';
  public appliedSupportRequestId: string | null = null;
  private supportModeSubscription?: Subscription;
  public isLoading: boolean = true;
  public cwData: any;
  public transactionTypes = TRANSACTION_TYPES;
  public pendingCount: number = 0;
  public enRevisionCount: number = 0;
  public processedCount: number = 0;
  public procesadoQueueCount: number = 0;
  public isProcessedQueueFiltered: boolean = false;
  private countRefreshInterval: ReturnType<typeof setInterval> | undefined;
  private processedQueueRefreshMs = DEFAULT_PROCESSED_QUEUE_MINUTES * 60 * 1000;
  public chargeNotIncomeCount: number = 0;
  public botProblemCount: number = 0;
  public totalCount: number = 0;
  public totalPagesVisible: any;
  public profile$ = this.store.select(selectAuth);
  public profile: User | null = null;
  public rol!: Number;
  messageSubscription: Subscription;
  private filtersSubscription!: Subscription;
  private countsResyncTrigger = new Subject<void>();
  private countsResyncSubscription: Subscription;
  dataSocket: { action: string; data: any } = { action: '', data: {} };
  public collectionSize: number = 0;
  public page: number = 1;
  public limit: number = 10;
  public roles = ROLES;
  public item!: itemUpdateCw;
  public country!: Number;
  public ORIGINS = ORIGIN;
  public CROSS_REQUEST = IS_CROSS_REQUEST;
  public CREATED_BY_AGENT = CREATED_BY_AGENT;
  public ROLES = ROLES;
  public REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS =
    REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS;
  public REQUEST_WITHDRAWAL_PERMISSIONS = REQUEST_WITHDRAWAL_PERMISSIONS;

  public selectedFilter: any;
  public defaultFilter: any;
  public subscribe: Subscription = new Subscription();
  public TRANSACTION_TYPE_VALUES = TRANSACTION_TYPE_VALUES;
  public STATE_NAMES = STATE_NAMES;

  public startDate = CONFIG_BASE_DATE_RANGEPICKER.initialRange[0];
  public endDate = CONFIG_BASE_DATE_RANGEPICKER.initialRange[1];
  public totalDolares: string = '';
  public totalSoles: string = '';
  public correctionUsed: { [key: string]: boolean } = {};

  public isMobile: boolean = false;
  public token!: string;

  public buttonAllowed: boolean = false;
  public buttonFastViewAllowed: boolean = false;
  public buttonDownloadExcelAllowed: boolean = false;
  public isSocketPaused: boolean = false;
  public pendingUpdates: any[] = [];
  public botFailedIds = new Set<number>();
  private readonly BOT_FAILED_KEY = 'cw_bot_failed_ids';
  public isCrossRequest: boolean = false;

  // REDUX
  public isMobile$ = this.store.select(selectScreen);
  public isMobileRedux!: boolean;
  private modalClosedSub!: Subscription;
  public isRepeatedVouchersViewerMinimized: boolean = false;

  // CARD
  public actualIndex!: number;
  public actualItemClient: any;
  public actualItemEnterprise: any;
  public cardExpanded: boolean[] = [];
  public subMenuItem: any;
  public actualItem!: any[];
  public itemType!: string;
  public buttons: any[] = [];

  public statePermissionMap: Record<number, number> = STATE_PERMISSION_MAP;

  constructor(
    private cwService: ChargesWithdrawalsRequestService,
    private dynamicModal: DynamicModalService,
    private socketService: SocketService,
    private _toastrSvc: ToastrService,
    private store: Store,
    private _filterCommunicationService: FilterCommunicationService,
    private router: Router,
    private activedRouter: ActivatedRoute,
    private _userService: UserService,
    private alertService: AlertService,
    private excelExportService: ExcelExportService,
    private ngZone: NgZone,
    private supportModeService: SupportModeService,
    private botWithdrawalService: BotWithdrawalService,
  ) {
    this.socketService.joinRoom(environment.ROOM_SOCKET_CW);
    this.messageSubscription = this.socketService
      .getMessageRoomSubject()
      .subscribe((msg) => {
        this.ngZone.run(() => {
          if (this.isSocketPaused) {
            this.pendingUpdates.push(msg);
          } else {
            this.processSocketData(msg);
          }
        });
      });
    this.countsResyncSubscription = this.countsResyncTrigger
      .pipe(debounceTime(1000))
      .subscribe(() => this.refreshCountsSilently());
  }
  async ngOnInit(): Promise<void> {
    this.loadBotFailedFromStorage();
    const fullUrl = this.router.url;
    this.isMobile = fullUrl.includes('/mobile');
    this.isMobile$.subscribe((isMobile) => {
      this.isMobileRedux = isMobile;
    });
    this.applyTableColumns();
    this.supportModeSubscription = this.supportModeService.isEnabled$.subscribe(
      (isEnabled) => {
        this.isSupportMode = isEnabled;
        this.applyTableColumns();
        // Turning support mode off must not leave a hidden id search applied.
        if (!isEnabled && this.appliedSupportRequestId) {
          this.clearSupportRequestId();
        }
      },
    );
    if (this.isMobile) {
      await this.loadTokenLogged();
    } else {
      await this.loadProfileLogged();
    }
    this.getDataFromFilter();
    this.listenRepeatedVouchersModalState();
    this.countRefreshInterval = setInterval(() => this.refreshCountsSilently(), this.processedQueueRefreshMs);
    this.startBotLockTimer();
  }

  ngOnDestroy(): void {
    this.socketService.leaveRoom(environment.ROOM_SOCKET_CW);
    this.subscribe.unsubscribe();
    this.modalClosedSub?.unsubscribe();
    this.countsResyncSubscription?.unsubscribe();
    this.supportModeSubscription?.unsubscribe();
    clearInterval(this.countRefreshInterval);
    clearInterval(this.botBusyCountdown);
    this.stopBotLockTimer();
  }

  private applyTableColumns(): void {
    const visibleColumns = this.isMobile
      ? columnsTable.filter(
          (column) =>
            !['Cliente', 'Comprobante', 'Actualizado', 'Creado Por'].includes(
              column.name,
            ),
        )
      : [...columnsTable];

    this.columnsTable = this.isSupportMode
      ? [{ name: SUPPORT_ID_COLUMN_NAME }, ...visibleColumns]
      : visibleColumns;
  }

  refreshAgentProfile(): void {
    if (!this.profile?.idusuario) {
      return;
    }

    this._userService.getUser(String(this.profile.idusuario)).subscribe({
      next: (res) => {
        if (res?.data) {
          this.store.dispatch(AuthActions['[Auth]UpdateUser'](res.data));
        }
      },
      error: (err: HttpErrorResponse) => {
        console.error('❌ Error al refrescar perfil:', err);
      },
    });
  }

  async loadProfileLogged() {
    await new Promise<void>((resolve, reject) => {
      this.profile$.subscribe({
        next: (res) => {
          if (res.idusuario !== -1) {
            this.profile = res;
            this.rol = res.id_rol;
            this.country = res.id_pais;
            this.mainButton();
            resolve();
          }
        },
        error: (err: unknown) => {
          reject(err);
        },
      });
    });
  }

  async loadTokenLogged() {
    await new Promise<void>((resolve, reject) => {
      this.activedRouter.params.subscribe((params) => {
        this.token = params['token'];
        this._userService.getUserByTokenApp(this.token).subscribe({
          next: (res) => {
            if (res.data.idusuario) {
              this.profile = res.data;
              this.rol = this.profile.id_rol;
              this.country = this.profile.id_pais;
              this.mainButton();
              resolve();
            } else {
              reject(new Error('No user id found'));
            }
          },
          error: (err: HttpErrorResponse) => {
            reject(err);
          },
        });
      });
    });
  }

  getStateClasses(state: number) {
    return STATE_CLASSES[state] || { text: '', classes: {} };
  }

  toggleSocket(): void {
    this.isSocketPaused = !this.isSocketPaused;

    if (this.isSocketPaused) {
      this._toastrSvc.info('Las solicitudes han sido pausadas.');
    } else {
      this._toastrSvc.info('Las solicitudes han sido reanudadas.');
      if (this.pendingUpdates.length > DEFAULT_VALUE) {
        this.pendingUpdates.forEach((update) => {
          this.processSocketData(update);
        });
        this.pendingUpdates = [];
      }
    }
  }

  onDropdownToggle(isOpen: boolean): void {
    if (isOpen) {
      this.isSocketPaused = true;
      this._toastrSvc.info('Las solicitudes han sido pausadas.');
    } else {
      this.isSocketPaused = false;
      this._toastrSvc.info('Las solicitudes han sido reanudadas.');
      if (this.pendingUpdates.length > DEFAULT_VALUE) {
        this.pendingUpdates.forEach((update) => {
          this.processSocketData(update);
        });
        this.pendingUpdates = [];
      }
    }
  }

  private addBotFailed(id: number): void {
    this.botFailedIds.add(id);
    try {
      const stored = JSON.parse(localStorage.getItem(this.BOT_FAILED_KEY) || '[]');
      if (!stored.includes(id)) stored.push(id);
      localStorage.setItem(this.BOT_FAILED_KEY, JSON.stringify(stored));
    } catch (_) {}
  }

  private removeBotFailed(id: number): void {
    this.botFailedIds.delete(id);
    try {
      const stored: number[] = JSON.parse(localStorage.getItem(this.BOT_FAILED_KEY) || '[]');
      localStorage.setItem(this.BOT_FAILED_KEY, JSON.stringify(stored.filter(x => x !== id)));
    } catch (_) {}
  }

  private loadBotFailedFromStorage(): void {
    try {
      const stored: number[] = JSON.parse(localStorage.getItem(this.BOT_FAILED_KEY) || '[]');
      stored.forEach(id => this.botFailedIds.add(id));
    } catch (_) {}
  }

  processSocketData(msg: { action: string; data: any }): void {
    if (msg?.action === 'bot_live_failed') {
      const solicitudId = msg.data?.solicitudId;
      if (solicitudId) this.addBotFailed(Number(solicitudId));
      return;
    }

    if (
      msg?.action === ACTION_SOCKET.UPDATE ||
      msg?.action === ACTION_SOCKET.ADD
    ) {
      msg.data.forEach((item: ChargesWithdrawalsRequestItem) => {
        const hasHumanOperator = !!(item.pagosOperator || item.atcOperator || item.otherOperator);
        const isTerminalState = Number(item.estado) >= 2;
        if (hasHumanOperator || isTerminalState) this.removeBotFailed(item.id);
        if (
          item.tipo_transaccion === TRANSACTION_TYPE_VALUES.FINANCIAL &&
          !this.canViewFinancial()
        ) {
          return;
        }
        this.updateItemList(item, msg.action);
      });
      this.countsResyncTrigger.next();
    }
  }

  getTransactionIconClass(type: number): string {
    return TRANSACTION_ICON_CLASSES[type] || '';
  }

  getTransactionClass(type: number): string {
    return TRANSACTION_CLASSES[type] || '';
  }

  onMoreButtonClick(item: itemUpdateCw): void {
    const hasPaymentsAccess = this.hasPermission(REQUEST_WITHDRAWAL_PERMISSIONS.CW_TEMP_LOCK);
    const hasAtcAccess = this.hasPermission(REQUEST_WITHDRAWAL_PERMISSIONS.ATC_CONCURRENT_LOCK);

    if (!hasPaymentsAccess && !hasAtcAccess) {
      return;
    }

    const montoOriginal = item.monto!.trim();
    const montoConFormato = montoOriginal
      .replace(/[$S/]/g, '')
      .replace(/−/g, '-')
      .replace(/\s/g, '');

    const montoSinMoneda = parseFloat(montoConFormato.replace(',', '.'));
    const formattedName = this.formatName(item.nombre_titular);
    const cleanedItem = {
      ...item,
      monto: montoSinMoneda,
      formatted_name: formattedName,
    };
    this.sendSetRequest(cleanedItem);
  }

  private sendSetRequest(cleanedItem: any, forceAtc = false): void {
    const payload = forceAtc ? { ...cleanedItem, force_atc: true } : cleanedItem;
    this.cwService.setRequest(payload).subscribe({
      next: (res) => {
        this._toastrSvc.success('Solicitud Asignada a ' + this.profile.usuario);
        this.removeBotFailed(cleanedItem.id);
        this.updateItemList({
          ...cleanedItem,
          updated_by: res.data.updated_by,
          id_usuario_set: res.data.id_usuario_set,
          atcOperator: res.data.atcOperator,
          pagosOperator: res.data.pagosOperator,
          otherOperator: res.data.otherOperator,
        }, ACTION_SOCKET.UPDATE);
      },
      error: (error: HttpErrorResponse) => {
        const backendCode = error?.error?.code || error?.error?.data?.code;

        if (backendCode === 'ATC_CONCURRENT_CONFLICT' && this.hasPermission(REQUEST_WITHDRAWAL_PERMISSIONS.ATC_CONCURRENT_LOCK)) {
          const lockedBy = error?.error?.data?.lockedBy || 'otro operador ATC';
          Swal.fire({
            title: 'Operador ATC en proceso',
            text: `${lockedBy} ya está trabajando en esta solicitud. ¿Deseas continuar de todas formas?`,
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Continuar',
            allowOutsideClick: false,
            allowEscapeKey: false,
            confirmButtonColor: '#4CAF50',
            cancelButtonColor: '#d33',
          }).then((result) => {
            if (result.isConfirmed) {
              this.sendSetRequest(cleanedItem, true);
            }
          });
          return;
        }

        if (backendCode === 'PREVIOUS_OPERATOR_CONFIRMATION_REQUIRED') {
          const previousOperator = error?.error?.data?.previousOperator || 'otro operador';
          Swal.fire({
            title: 'Solicitud asignada anteriormente',
            text: `Esta solicitud está asignada a ${previousOperator}. ¿Deseas continuar con el proceso?`,
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Seguir con el proceso',
            allowOutsideClick: false,
            allowEscapeKey: false,
            confirmButtonColor: '#4CAF50',
            cancelButtonColor: '#d33',
          }).then((result) => {
            if (result.isConfirmed) {
              this.sendSetRequest(cleanedItem, true);
            }
          });
          return;
        }

        const message = extractErrorMessage(
          error,
          'es',
          'La solicitud ya está siendo modificada por otro usuario.',
        );

        if (error?.status === 409) {
          Swal.fire({
            title: 'Solicitud en modificación',
            text: message,
            icon: 'warning',
            confirmButtonText: 'Entendido',
            allowOutsideClick: false,
            allowEscapeKey: false,
            confirmButtonColor: '#4CAF50',
          });
          return;
        }

        this._toastrSvc.error('Error al asignar el usuario');
      },
    });
  }

  // SUPPORT MODE: search by request id. Kept apart from the filter panel so applying
  // or resetting other filters keeps it; the backend ignores the dates when it is set.
  searchByRequestId(): void {
    const value = this.supportRequestId.trim();
    if (!value) {
      this.clearSupportRequestId();
      return;
    }
    if (!/^\d+$/.test(value)) {
      this._toastrSvc.warning('El ID de solicitud solo admite números.');
      return;
    }
    this.appliedSupportRequestId = value;
    this.page = 1;
    this.getData();
  }

  clearSupportRequestId(): void {
    const hadSearch = !!this.appliedSupportRequestId;
    this.supportRequestId = '';
    this.appliedSupportRequestId = null;
    if (hadSearch) {
      this.page = 1;
      this.getData();
    }
  }

  private withSupportRequestId(filter: any): any {
    return { ...filter, request_id: this.appliedSupportRequestId };
  }

  getData() {
    this.startLoading();
    this.defaultFilter = this.selectedFilter || this.getDefaultFilter();
    this.cwService
      .getAllData(this.page, this.limit, this.withSupportRequestId(this.defaultFilter))
      .pipe(finalize(() => this.stopLoading()))
      .subscribe({
        next: (res) => {
          this.processResponse(res.data);
        },
        error: () => {
          this.cwData = [];
        },
      });
  }

  getDefaultFilter() {
    return this.selectedFilter
      ? this.selectedFilter
      : {
          id_rol: '0',
          date_star: moment(this.startDate).format(FILTER_DATETIME_FORMAT),
          date_end: moment(this.endDate).format(DEFAULT_DATETIME_FORMATS.END),
        };
  }

  formatTotals(totals: any) {
    this.totalDolares = formatAmount(Number(totals.ecuador), COUNTRY_CODES_DEFAULT.EC);
    this.totalSoles = formatAmount(Number(totals.peru), COUNTRY_CODES_DEFAULT.PE);
  }

  processResponse(response: ChargesWithdrawalsRequestListData) {
    this.formatTotals(response.totals);

    const filteredData = response.data.filter((item: ChargesWithdrawalsRequestItem) => {
      if (item.tipo_transaccion === TRANSACTION_TYPE_VALUES.FINANCIAL) {
        return this.canViewFinancial();
      }
      return true;
    });

    filteredData.forEach((item: ChargesWithdrawalsRequestItem) => {
      const hasHumanOperator = !!(item.pagosOperator || item.atcOperator || item.otherOperator);
      const isTerminalState = Number(item.estado) >= 2;
      if (hasHumanOperator || isTerminalState) this.removeBotFailed(item.id);
    });
    this.cwData = filteredData.map((item: ChargesWithdrawalsRequestItem) => this.formatCwData(item));
    const visibleData = filteredData.filter((item: ChargesWithdrawalsRequestItem) =>
      this.canViewRowByState(item.estado),
    );
    const totalCount = this.getTotalCount(response, visibleData.length);
    this.collectionSize = totalCount;
    this.isCrossRequest = filteredData.some(
      (item: ChargesWithdrawalsRequestItem) => item.solicitud_cruzada === 1,
    );
    this.emitChanges(response.counts, totalCount);
    this.syncRefreshInterval(response.processedQueueMinutes);
  }

  emitChanges(counts: ChargesWithdrawalsRequestCounts, totalCount: number) {
    this.totalPendingChange.emit(counts.pendiente);
    this.enRevisionCount = counts.enRevision ?? 0;
    this.totalEnRevisionChange.emit(this.enRevisionCount);
    this.totalProcessedChange.emit(counts.procesado);
    this.totalChargeNotIncomeChange.emit(counts.cargadoNoIngresado);
    this.totalBotProblemChange.emit(counts.problemaBot);
    this.totalCorrectionChange.emit(counts.correcion);
    this.totalReverseChange.emit(counts.reverse);
    this.totalCountChange.emit(totalCount);
    this.procesadoQueueCount = counts.procesadoQueue ?? 0;
  }

  filterByProcessed(): void {
    const filter = this.selectedFilter || this.getDefaultFilter();
    this._filterCommunicationService.changeFilter({
      ...filter,
      id_rol: '0',
      state: [REQUEST_STATUS.PROCESSED],
      processed_queue: true,
    });
  }

  resetProcessedFilter(): void {
    const { processed_queue: _removed, state: _state, ...rest } = this.selectedFilter || {};
    this._filterCommunicationService.changeFilter({ ...rest, state: [] });
  }

  private syncRefreshInterval(processedQueueMinutes: number | undefined): void {
    if (processedQueueMinutes == null) return;
    const newMs = processedQueueMinutes * 60 * 1000;
    if (newMs === this.processedQueueRefreshMs) return;
    this.processedQueueRefreshMs = newMs;
    clearInterval(this.countRefreshInterval);
    this.countRefreshInterval = setInterval(() => this.refreshCountsSilently(), this.processedQueueRefreshMs);
  }

  private refreshCountsSilently(): void {
    const filter = this.withSupportRequestId(this.selectedFilter || this.getDefaultFilter());
    this.cwService.getCounts(filter).subscribe({
      next: (res) => {
        if (!res.data?.counts) return;
        const totalCount = this.getTotalCount(res.data, this.collectionSize);
        this.collectionSize = totalCount;
        this.emitChanges(res.data.counts, totalCount);
      },
      error: () => {},
    });
  }

  private updateProcessedQueueCount(
    oldItem: Pick<ChargesWithdrawalsRequestItem, 'estado' | 'tipo_transaccion'> | undefined,
    newItem: Pick<ChargesWithdrawalsRequestItem, 'estado' | 'tipo_transaccion'>,
    typeAction: string,
  ): void {
    const CREDIT_TYPES = [
      TRANSACTION_TYPE_VALUES.CREDIT_DEPOSIT,
      TRANSACTION_TYPE_VALUES.CREDIT_WITHDRAWAL,
    ];
    const isQueueItem = (
      item: Pick<ChargesWithdrawalsRequestItem, 'estado' | 'tipo_transaccion'> | undefined,
    ): boolean =>
      item?.estado === REQUEST_STATUS.PROCESSED &&
      !CREDIT_TYPES.includes(item?.tipo_transaccion ?? -1);

    if (typeAction === ACTION_SOCKET.ADD) {
      if (isQueueItem(newItem)) this.procesadoQueueCount++;
    } else if (typeAction === ACTION_SOCKET.UPDATE && oldItem) {
      const wasInQueue = isQueueItem(oldItem);
      const isInQueue = isQueueItem(newItem);
      if (!wasInQueue && isInQueue) this.procesadoQueueCount++;
      else if (wasInQueue && !isInQueue) this.procesadoQueueCount--;
    }
  }

  private getTotalCount(
    response: TotalCountResponse | null | undefined,
    fallback: number,
  ): number {
    const possibleTotals = [
      response?.totalCount,
      response?.total_count,
      response?.total,
      response?.count,
      response?.counts?.total,
      response?.counts?.totalCount,
      response?.pagination?.total,
    ];

    for (const total of possibleTotals) {
      if (typeof total === 'number' && Number.isFinite(total)) {
        return total;
      }
    }

    return fallback;
  }

  startLoading() {
    this.isLoading = true;
    this.loading.emit(true);
  }

  stopLoading() {
    this.isLoading = false;
    this.loading.emit(false);
  }

  reloadTable() {
    this.getData();
  }

  updateItemList(
    newItem: ChargesWithdrawalsRequestItem,
    typeAction: string = ACTION_SOCKET.ADD,
  ): void {
    if (
      newItem.tipo_transaccion === TRANSACTION_TYPE_VALUES.FINANCIAL &&
      !this.canViewFinancial()
    ) {
      return;
    }

    const existingItem = this.cwData?.find((item: FormattedCwItem) => item.id === newItem.id);
    const mergedItem: ChargesWithdrawalsRequestItem = existingItem
      ? {
          ...newItem,
          atcOperator: newItem.atcOperator ?? existingItem.atcOperator,
          pagosOperator: newItem.pagosOperator ?? existingItem.pagosOperator,
          otherOperator: newItem.otherOperator ?? existingItem.otherOperator,
          id_usuario_set: newItem.id_usuario_set ?? existingItem.id_usuario_set,
          updated_by: newItem.updated_by ?? existingItem.updated_by,
        }
      : newItem;

    const formattedItem: FormattedCwItem = this.formatCwData(mergedItem);
    const formattedRecord = formattedItem as unknown as Record<string, unknown>;
    const oldItem = this.cwData?.find((item: FormattedCwItem) => item.id === formattedItem.id);
    this.updateProcessedQueueCount(oldItem, formattedItem, typeAction);
    const filtersApplied = this.checkIfOtherFiltersApplied();

    if (this.selectedFilter.updated_by) {
      if (
        formattedItem.id_usuario_set &&
        formattedItem.id_usuario_set !== this.profile.idusuario
      ) {
        const index = this.cwData.findIndex(
          (item: FormattedCwItem) => item.id === formattedItem.id,
        );
        if (index !== -1) {
          this.cwData.splice(index, 1);
          return;
        }
      }
      if (formattedItem.id_usuario_set === this.profile.idusuario) {
        const index = this.cwData.findIndex(
          (item: FormattedCwItem) => item.id === formattedItem.id,
        );
        if (index === -1) {
          if (this.doesItemMatchFilters(formattedItem)) {
            if (this.page === 1) {
              this.cwData.unshift(formattedItem);
            }
          }
        } else {
          Object.keys(formattedRecord).forEach((key) => { this.cwData[index][key] = formattedRecord[key]; });
        }
        return;
      }
    }

    const index = this.cwData?.findIndex((item: FormattedCwItem) => item.id === formattedItem.id);

    if (index !== -1) {
      Object.keys(formattedRecord).forEach((key) => {
        if (this.cwData[index][key] !== formattedRecord[key]) {
          this.cwData[index][key] = formattedRecord[key];
        }
      });
    } else {
      if (typeAction === ACTION_SOCKET.ADD) {
        if (this.doesItemMatchFilters(formattedItem)) {
          if (this.page === 1) {
            this.cwData.unshift(formattedItem);
          }
        }
      }
    }
  }

  doesItemMatchFilters(item: any): boolean {
    const filters = this.selectedFilter;

    const conditions: {
      condition: unknown;
      value?: unknown;
      values?: unknown[];
    }[] = [
      {
        condition: filters.receipt,
        // Mirrors the server-side filter, which matches the receipt against
        // the client voucher OR the enterprise voucher.
        values: [item.comprobante, item.comprobante_empresa],
      },
      {
        condition: filters.amount,
        value: item.monto.replace(/[^0-9.-]+/g, ''),
      }, // Limpiar el monto para obtener el número
      { condition: filters.id_agente, value: item.id_agente },
      { condition: filters.id_jugador, value: item.id_jugador },
      {
        condition: filters.interbank_transfer,
        value: item.transferencia_interbancaria,
      },
      { condition: filters.transaction_type, value: item.tipo_transaccion },
      { condition: filters.state, value: item.estado },
      { condition: filters.bank, value: item.id_banco },
      { condition: filters.identification, value: item.identificacion },
      { condition: filters.beneficiary, value: item.beneficiario },
      { condition: filters.account_number, value: item.numero_cuenta },
      { condition: filters.created_by, value: item.id_usuario_add },
      { condition: filters.type_user, value: item.tipo_usuario },
      { condition: filters.holder, value: item.id_titular },
      { condition: filters.country, value: item.id_pais },
    ];

    const toComparable = (input: unknown): unknown =>
      !isNaN(Number(input)) ? Number(input) : input;

    for (const { condition, value, values } of conditions) {
      // A condition can be checked against more than one field (see receipt).
      const candidates = (values ?? [value]).filter(
        (candidate) =>
          candidate !== null && candidate !== undefined && candidate !== '',
      );

      const matchesCandidate = (expected: unknown): boolean =>
        candidates.some(
          (candidate) => toComparable(expected) === toComparable(candidate),
        );

      if (Array.isArray(condition)) {
        if (condition.length === 0) {
          continue;
        }
        if (!condition.some(matchesCandidate)) {
          return false;
        }
      } else if (condition) {
        if (!matchesCandidate(condition)) {
          return false;
        }
      }
    }

    const createdDate = new Date(item.actualizado);
    const filterStartDate = filters.date_star_update
      ? new Date(filters.date_star_update)
      : null;
    const filterEndDate = filters.date_end_update
      ? new Date(filters.date_end_update)
      : null;

    if (
      (filterStartDate && createdDate < filterStartDate) ||
      (filterEndDate && createdDate > filterEndDate)
    ) {
      return false;
    }

    return true;
  }

  checkIfOtherFiltersApplied(): boolean {
    return Object.keys(this.selectedFilter).some(
      (filter) =>
        filter !== DATE_TEXT.DATE_START &&
        filter != DATE_TEXT.DATE_END &&
        this.selectedFilter[filter],
    );
  }

  //FORMATTING DATA
  formatCwData(item: ChargesWithdrawalsRequestItem): FormattedCwItem {
    this.rememberBotLock(item);
    const monto = this.formatAmountWithCountry(item.monto, item.id_pais);

    const formattedName = this.formatName(item.nombre_titular);
    const formattedHolderName = this.formatName(item.holder);
    const initials = this.getInitials(item.updated_by);
    const operators = {
      pagos: this.getOperatorInfo(item.pagosOperator, item.id_usuario_set),
      atc: this.getOperatorInfo(item.atcOperator, item.id_usuario_set),
      other: this.getOperatorInfo(item.otherOperator, item.id_usuario_set),
    };
    return {
      ...item,
      monto: monto,
      updated_by_initials: initials.toUpperCase(),
      formatted_name: formattedName,
      formatted_holder_name: formattedHolderName,
      operators,
    };
  }

  private getOperatorInfo(
    operatorData: CwOperatorInfo | null | undefined,
    activeId: number | null | undefined,
  ): OperatorInfoView | null {
    if (!operatorData) return null;
    return {
      initials: this.getInitials(operatorData.nombres || operatorData.usuario).toUpperCase(),
      name: operatorData.nombres || operatorData.usuario || '',
      isActive: operatorData.idusuario === activeId,
    };
  }

  formatName(name?: string | null): string {
    const nameParts = name ? name.split(' ') : [];
    const firstName = nameParts.length > 0 ? nameParts[0].toLowerCase() : '';
    const lastName = nameParts.length > 1 ? nameParts[1].toLowerCase() : '';
    const formattedFirstName =
      firstName.charAt(0).toUpperCase() + firstName.slice(1);
    const formattedLastName =
      lastName.charAt(0).toUpperCase() + lastName.slice(1);
    return `${formattedFirstName} ${formattedLastName}`.trim();
  }

  getInitials(name?: string | null): string {
    const nameParts = name ? name.split(' ') : [];
    return nameParts.length > 1
      ? `${nameParts[0][0]}${nameParts[1][0]}`
      : nameParts.length > 0
        ? `${nameParts[0][0]}`
        : '';
  }

  formatAmountWithCountry(amount?: number, countryId?: number): string {
    return formatAmount(
      Number(amount),
      countryId === CURRENCY_VALUES.ECU ? 'EC' : 'PE',
    );
  }

  //PAGINATION AND FILTER

  onLimitChange(limit: number) {
    this.limit = limit;
    this.page = 1;
    this.getData();
  }

  onPageChange(page: number): void {
    this.page = page;
    this.getData();
  }

  getDataFromFilter() {
    this.subscribe = this._filterCommunicationService.currentFilter.subscribe(
      (filter) => {
        if (filter) {
          this.page = 1;
          this.selectedFilter = filter;
          const stateArr = filter.state;
          this.isProcessedQueueFiltered = !!filter.processed_queue;
          this.getData();
        }
      },
    );
  }

  // MODALS
  openImageModal(cwId: any) {
    this.dynamicModal.openModal(
      ImageViewComponent,
      'Comprobante',
      'md',
      true,
      cwId,
    );
  }

  openViewModal(cwId: any) {
    this.dynamicModal.openModal(
      ViewPayComponent,
      'Transacción',
      'xl',
      true,
      cwId,
    );
  }

  openRepeatedVouchersModal(): void {
    this.dynamicModal.openModal(
      RepeatedCwVouchersModalComponent,
      this.repeatedVouchersModalTitle,
      'lg',
      false,
      {
        currentFilter: this.selectedFilter,
      },
    );
  }

  toggleRepeatedVouchersViewer(): void {
    if (this.isRepeatedVouchersViewerMinimized) {
      this.dynamicModal.closeModal();
      return;
    }

    this.openRepeatedVouchersModal();
  }

  // openCreateCwFormModal() {
  //   if (this.rol === ROLES.AGENT) {
  //     this.dynamicModal.openModal(
  //       TransactionTypeSelectorComponent,
  //       'Selecciona un Tipo de Transacción',
  //       'lg',
  //       true,
  //       {
  //         countryId: this.country,
  //         dailyLoadLimit: this.profile?.monto_maximo_carga_diaria || 0,
  //         loadAmoutUsed: this.profile?.monto_usado_carga_actual || 0,
  //         dailyWithdrawalLimit: 500,
  //         WithdrawalAmoutUsed: 10,
  //       }
  //     );
  //   } else {
  //     this.dynamicModal.openModal(
  //       CreateCwRequestComponent,
  //       'Agregar Solicitud de Cargas o Retiros ',
  //       'xl',
  //       false,
  //       this.country
  //     );
  //   }
  // }

  openCreateCwFormModal() {
    if (this.rol === ROLES.AGENT) {
      this.dynamicModal.openModal(
        CreateCwRequestComponent,
        'Agregar Solicitud de Cargas o Retiros ',
        'xl',
        false,
        this.country,
      );
    } else {
      this.dynamicModal.openModal(
        CreateCwRequestComponent,
        'Agregar Solicitud de Cargas o Retiros',
        'xl',
        false,
        DEFAULT_CW_COUNTRY_ID,
      );
    }
  }

  openDetailAlert(item: any) {
    const hasAtcInfo =
      !!item.id_atc_revisor &&
      Number(item.tipo_transaccion) === TRANSACTION_TYPE_VALUES.WITHDRAW_BALANCE &&
      !!item.id_remoto;
    const atcSection = hasAtcInfo
      ? `
      <hr>
      <div style="text-align: left;">
        <div><strong>Revisado por:</strong> ${item.atcReviewer?.nombres || item.atcReviewer?.usuario || 'N/A'}</div>
        <div><strong>Fecha de revisión:</strong> ${item.fecha_revision_atc ? moment(item.fecha_revision_atc).utcOffset('-05:00').format('YYYY-MM-DD HH:mm') : 'N/A'}</div>
      </div>
    `
      : '';
    Swal.fire({
      title: `<strong>Detalle de la Solicitud</strong>`,
      icon: 'info',
      html: `
      <div>
        <br> ${item.detalle || 'N/A'}
      </div>
      ${atcSection}
    `,
      showCloseButton: true,
      focusConfirm: false,
      confirmButtonColor: '#54BA4A',
      cancelButtonColor: '#5A6268',
      iconColor: '#8C98A1',
      confirmButtonText: '<i class="fa fa-thumbs-up"></i> Entendido',
      confirmButtonAriaLabel: 'Thumbs up, great!',
      customClass: {
        popup: 'my-swal-popup',
      },
    });
  }

  openReverseCw(id: any, estado: any, country: number) {
    this.dynamicModal.openModal(
      ReverseCwRequestComponent,
      'Reverso de Solicitud de Cargas o Retiros',
      'xl',
      false,
      { id, estado, country },
    );
  }

  openEditCw(
    id: number,
    estado: number,
    tipoTransaccion?: number,
    fotoComprobante?: string,
    id_financiero?: number,
    isCorrectionEdit = false,
  ) {
    this.dynamicModal.openModal(
      EditCwRequestComponent,
      'Edición de Solicitud de Cargas o Retiros',
      'xl',
      false,
      {
        id,
        estado,
        tipoTransaccion,
        fotoComprobante,
        id_financiero,
        isCorrectionEdit,
        isEditForm: true,
      },
    );
  }

  openDivideCw(id: any) {
    this.dynamicModal.openModal(
      DivideCwRequestComponent,
      'División de Transacción',
      'md',
      false,
      id,
    );
  }

  openPayOutCw(id: number) {
    this.dynamicModal.openModal(
      ViewPayOutDetailComponent,
      'Detalles de pago',
      'md',
      false,
      id,
    );
  }

  setState(id: number, newState: number, idusuarioSet: number) {
    this.alertService
      .showConfirmAlert(
        '¿Estás seguro?',
        'No podrás revertir esto!',
        'Sí, cambiar estado!',
        'Cancelar',
      )
      .then((result) => {
        if (result.isConfirmed) {
          if (
            newState === STATE_NAMES.REJECTED ||
            newState === STATE_NAMES.CORRECTION
          ) {
            this.alertService
              .showInputAlert(
                'Escribe el motivo del rechazo',
                'Motivo',
                'Escribe aquí...',
                'Enviar motivo',
                'Cancelar',
              )
              .then((textResult) => {
                if (textResult.isConfirmed && textResult.value) {
                  this.updateStateWithReason(
                    id,
                    newState,
                    idusuarioSet,
                    textResult.value,
                  );
                }
              });
          } else {
            this.updateState(id, newState, idusuarioSet);
          }
        }
      });
  }

  updateState(id: number, newState: number, idusuarioSet: number) {
    this.cwService.setState(id, newState, idusuarioSet).subscribe(
      () => {
        this._toastrSvc.success('Cambio de estado exitoso', '', {
          progressBar: true,
          positionClass: 'custom-toastr-top',
        });
      },
      (error: HttpErrorResponse) => {
        if (
          this.handleRepeatedVoucherConfirmation(
            error,
            { id, newState, idusuarioSet },
            () => this.updateStateWithRepeatedVoucher(id, newState, idusuarioSet),
          )
        ) {
          return;
        }
        // El http-error.interceptor muestra el toast con el mensaje del backend.
      },
    );
  }

  updateStateWithReason(
    id: number,
    newState: number,
    idusuarioSet: number,
    reason: string,
  ) {
    this.cwService.setState(id, newState, idusuarioSet, reason).subscribe(
      () => {
        this._toastrSvc.success('Cambio de estado exitoso', '', {
          progressBar: true,
          positionClass: 'custom-toastr-top',
        });
      },
      (error: HttpErrorResponse) => {
        if (
          this.handleRepeatedVoucherConfirmation(
            error,
            { id, newState, idusuarioSet, reason },
            () =>
              this.updateStateWithReasonAndRepeatedVoucher(
                id,
                newState,
                idusuarioSet,
                reason,
              ),
          )
        ) {
          return;
        }
        // El http-error.interceptor muestra el toast con el mensaje del backend.
      },
    );
  }

  updateStateWithRepeatedVoucher(
    id: number,
    newState: number,
    idusuarioSet: number,
  ) {
    this.cwService
      .setState(id, newState, idusuarioSet, undefined, undefined, true)
      .subscribe({
        next: () => {
          this._toastrSvc.success('Cambio de estado exitoso', '', {
            progressBar: true,
            positionClass: 'custom-toastr-top',
          });
        },
        error: () => {
          // El http-error.interceptor muestra el toast con el mensaje del backend.
        },
      });
  }

  updateStateWithReasonAndRepeatedVoucher(
    id: number,
    newState: number,
    idusuarioSet: number,
    reason: string,
  ) {
    this.cwService
      .setState(id, newState, idusuarioSet, reason, undefined, true)
      .subscribe({
        next: () => {
          this._toastrSvc.success('Cambio de estado exitoso', '', {
            progressBar: true,
            positionClass: 'custom-toastr-top',
          });
        },
        error: () => {
          // El http-error.interceptor muestra el toast con el mensaje del backend.
        },
      });
  }

  private handleRepeatedVoucherConfirmation(
    error: HttpErrorResponse,
    context: {
      id: number;
      newState: number;
      idusuarioSet: number;
      reason?: string;
    },
    onConfirm: () => void,
  ): boolean {
    const errorCode = error?.error?.code || error?.error?.data?.code;

    if (errorCode !== 'REPEATED_VOUCHER_CONFIRMATION_REQUIRED') {
      return false;
    }

    const message = extractErrorMessage(
      error,
      'es',
      'Se detectó un comprobante repetido. ¿Deseas continuar de todos modos?',
    );

    const modalRef = this.dynamicModal.openModal(
      RepeatedVoucherActionModalComponent,
      'Comprobante repetido',
      'md',
      true,
      { message },
    );

    modalRef.result.then(
      (result: { action?: string }) => {
        if (result?.action === 'continue') {
          onConfirm();
          return;
        }

        if (result?.action === 'reject') {
          this.updateStateWithReason(
            context.id,
            STATE_NAMES.REJECTED,
            context.idusuarioSet,
            this.DUPLICATE_VOUCHER_REJECT_REASON,
          );
        }
      },
      () => {},
    );

    return true;
  }

  private listenRepeatedVouchersModalState(): void {
    this.subscribe.add(
      this.dynamicModal.modalStateChanged.subscribe((state) => {
        if (state.title !== this.repeatedVouchersModalTitle) {
          return;
        }

        this.isRepeatedVouchersViewerMinimized =
          state.isOpen && state.isMinimized;
      }),
    );
  }

  // BUTTONS
  mainButton() {
    const mainPermission = this.profile?.rol?.permisos_principales;
    const subscriptionsPayments = mainPermission.find(
      (permission: { id: number }) =>
        permission.id === MAIN_PERMISSIONS['Abonos y Pagos'],
    );

    if (subscriptionsPayments) {
      this.buttonAllowed = subscriptionsPayments.permisos.some(
        (permissionButton: { id: number; activar: number }) =>
          permissionButton.id ===
          REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS.NEW_REQUEST,
      );
      this.buttonFastViewAllowed = subscriptionsPayments.permisos.some(
        (permissionButton: { id: number; activar: number }) =>
          permissionButton.id ===
          REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS.FAST_VIEW,
      );
      this.buttonDownloadExcelAllowed = subscriptionsPayments.permisos.some(
        (permissionButton: { id: number; activar: number }) =>
          permissionButton.id ===
          REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS.DOWNLOAD_EXCEL,
      );
    }
  }

  createButton(
    tooltip: string,
    icon: string,
    btnClass: string,
    action: () => void,
    item?: any,
  ) {
    return { tooltip, icon, btnClass, action, item };
  }

  hasPermission(permissionId: number): boolean {
    return this.profile?.rol?.permisos_principales.some(
      (permisoPrincipal: any) =>
        permisoPrincipal.permisos.some(
          (permiso: any) => permiso.id === permissionId,
        ),
    );
  }

  private canViewFinancial(): boolean {
    const isRestrictedRole =
      this.profile?.rol?.id === ROLES.PERSONAL_SERVICE ||
      this.profile?.rol?.id === ROLES.SERVICE_BOSS;
    if (isRestrictedRole) return false;
    return this.hasPermission(REQUEST_WITHDRAWAL_PERMISSIONS.GET_FINANCIAL_DATA);
  }

  canViewRowByState(estado?: number): boolean {
    const permissionId = this.statePermissionMap[estado];
    if (!permissionId) {
      return true;
    }
    return this.hasPermission(permissionId);
  }

  botLockNow: number = Date.now();
  private botLocks = new Map<number, BotLock>();
  private botLockTimer: ReturnType<typeof setInterval> | null = null;
  private botBusyCountdown: ReturnType<typeof setInterval> | null = null;

  rememberBotLock(item: ChargesWithdrawalsRequestItem): void {
    const id = Number(item?.id);

    if (!id || !item || !('bot_lock' in item)) return;

    const candado = item.bot_lock;

    if (candado?.locked && candado.expiresAt) {
      this.botLocks.set(id, candado);
      this.botLockNow = Date.now();
    } else {
      this.botLocks.delete(id);
    }
  }

  getBotLock(item: FormattedCwItem | null): BotLock | null {
    return this.botLocks.get(Number(item?.id)) || null;
  }

  isBotLocked(item: FormattedCwItem | null): boolean {
    const candado = this.getBotLock(item);

    if (!candado?.expiresAt) return false;

    return new Date(candado.expiresAt).getTime() > this.botLockNow;
  }

  botLockRemaining(item: FormattedCwItem | null): string {
    const expira = this.getBotLock(item)?.expiresAt;

    if (!expira) return '';

    const restante = new Date(expira).getTime() - this.botLockNow;

    if (restante <= 0) return '';

    const total = Math.ceil(restante / 1000);
    const minutos = Math.floor(total / 60);
    const segundos = total % 60;

    return `${minutos}:${String(segundos).padStart(2, '0')}`;
  }

  private startBotLockTimer(): void {
    if (this.botLockTimer) return;

    this.ngZone.runOutsideAngular(() => {
      this.botLockTimer = setInterval(() => {
        if (!this.botLocks.size) return;

        const ahora = Date.now();
        const vencidos: number[] = [];

        this.botLocks.forEach((candado, id) => {
          if (new Date(candado.expiresAt).getTime() <= ahora) vencidos.push(id);
        });

        vencidos.forEach((id) => this.botLocks.delete(id));

        this.ngZone.run(() => {
          this.botLockNow = ahora;
        });
      }, 1000);
    });
  }

  private stopBotLockTimer(): void {
    if (!this.botLockTimer) return;
    clearInterval(this.botLockTimer);
    this.botLockTimer = null;
  }

  showBotBusyAlert(item: FormattedCwItem): void {
    const candado = this.getBotLock(item);
    const quien = candado?.sentByName;
    const expira = candado?.expiresAt
      ? new Date(candado.expiresAt).getTime()
      : 0;

    const origen = quien ? `Enviada por <b>${quien}</b>.` : '';

    Swal.fire({
      title: 'Bot ocupado',
      html: `${origen}<br>Se libera en <b id="bot-busy-countdown">${this.botLockRemaining(item)}</b>`,
      icon: 'info',
      confirmButtonText: 'Entendido',
      didOpen: () => {
        const nodo = document.getElementById('bot-busy-countdown');
        if (!nodo || !expira) return;

        const tick = setInterval(() => {
          const restante = expira - Date.now();

          if (restante <= 0) {
            clearInterval(tick);
            Swal.close();
            return;
          }

          const total = Math.ceil(restante / 1000);
          nodo.textContent = `${Math.floor(total / 60)}:${String(
            total % 60,
          ).padStart(2, '0')}`;
        }, 1000);

        this.botBusyCountdown = tick;
      },
      willClose: () => {
        clearInterval(this.botBusyCountdown);
      },
    });
  }

  onActionClick(item: FormattedCwItem, btn: CwActionButton): void {
    if (this.isBotLocked(item)) {
      this.showBotBusyAlert(item);
      return;
    }

    btn.action();
  }

  sendWithdrawalToBot(item: FormattedCwItem): void {
    Swal.fire({
      title: '¿Mandar este pago al bot?',
      html: `El bot va a transferir <b>${item.monto}</b> desde el banco. La transferencia no se puede deshacer.`,
      icon: 'warning',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Directa',
      denyButtonText: 'Interbancaria',
      cancelButtonText: 'Cancelar',
      customClass: { denyButton: 'bg-warning' },
    }).then((result) => {
      if (result.isConfirmed) {
        this.dispatchToBot(item, false);
      } else if (result.isDenied) {
        this.askInterbankBank(item);
      }
    });
  }

  private askInterbankBank(item: FormattedCwItem): void {
    this.botWithdrawalService.getOperableBanks().subscribe({
      next: (response) => {
        const banks = response?.data ?? [];

        if (!banks.length) {
          this._toastrSvc.error(
            'No hay bancos con titulares habilitados para el bot.',
            'Bot de retiros',
          );
          return;
        }

        const options = banks
          .map(
            (bank) =>
              `<li class="bot-bank__option" role="option" data-id="${bank.id}">${this.escapeHtml(bank.name)}</li>`,
          )
          .join('');

        let selectedId: number | null = null;

        Swal.fire({
          title: 'Transferencia interbancaria',
          html: `
            <p class="bot-bank__hint">Elige a qué banco debe entrar el bot para hacer la transferencia.</p>
            <div class="bot-bank">
              <button type="button" class="bot-bank__toggle" aria-haspopup="listbox" aria-expanded="false">
                <span class="bot-bank__label"> Selecciona un banco</span>
                <span class="bot-bank__caret">&#9662;</span>
              </button>
              <div class="bot-bank__panel" hidden>
                <input type="text" class="bot-bank__search" placeholder="Buscar banco..." autocomplete="off">
                <ul class="bot-bank__list" role="listbox">${options}</ul>
                <p class="bot-bank__empty" hidden>Sin resultados</p>
              </div>
            </div>`,
          showCancelButton: true,
          confirmButtonText: 'Mandar al bot',
          cancelButtonText: 'Cancelar',
          preConfirm: () => {
            if (!selectedId) {
              Swal.showValidationMessage('Debes elegir un banco');
              return false;
            }
            return selectedId;
          },
          didOpen: () => {
            const root = Swal.getHtmlContainer();
            const toggle = root?.querySelector<HTMLButtonElement>('.bot-bank__toggle');
            const panel = root?.querySelector<HTMLDivElement>('.bot-bank__panel');
            const list = root?.querySelector<HTMLUListElement>('.bot-bank__list');
            const label = root?.querySelector<HTMLSpanElement>('.bot-bank__label');
            const search = root?.querySelector<HTMLInputElement>('.bot-bank__search');
            const empty = root?.querySelector<HTMLParagraphElement>('.bot-bank__empty');
            if (!toggle || !panel || !list || !label || !search || !empty) return;

            const opciones = Array.from(
              list.querySelectorAll<HTMLLIElement>('.bot-bank__option'),
            );

            toggle.addEventListener('click', () => {
              const abierto = !panel.hidden;
              panel.hidden = abierto;
              toggle.setAttribute('aria-expanded', String(!abierto));
              if (!abierto) {
                search.focus();
              }
            });

            search.addEventListener('input', () => {
              const buscado = this.normalizeForSearch(search.value);
              let visibles = 0;
              opciones.forEach((option) => {
                const coincide =
                  !buscado ||
                  this.normalizeForSearch(option.textContent || '').includes(buscado);
                option.hidden = !coincide;
                if (coincide) visibles += 1;
              });
              empty.hidden = visibles > 0;
            });

            list.addEventListener('click', (event) => {
              const option = (event.target as HTMLElement).closest<HTMLLIElement>(
                '.bot-bank__option',
              );
              if (!option) return;
              selectedId = Number(option.dataset['id']);
              label.textContent = option.textContent;
              opciones.forEach((el) => el.classList.remove('is-selected'));
              option.classList.add('is-selected');
              panel.hidden = true;
              toggle.setAttribute('aria-expanded', 'false');
              Swal.resetValidationMessage();
            });
          },
        }).then((result) => {
          if (result.isConfirmed && result.value) {
            this.dispatchToBot(item, true, Number(result.value));
          }
        });
      },
      error: (error: HttpErrorResponse) =>
        this._toastrSvc.error(
          extractErrorMessage(error, 'es', 'No se pudo cargar la lista de bancos.'),
          'Bot de retiros',
        ),
    });
  }

  // Sin acentos ni mayusculas, para que "pacifico" encuentre "Pacífico".
  private normalizeForSearch(value: string): string {
    return String(value)
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .trim();
  }

  private escapeHtml(value: string): string {
    return String(value).replace(
      /[&<>"']/g,
      (char) =>
        ({
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#39;',
        })[char] as string,
    );
  }

  private dispatchToBot(
    item: FormattedCwItem,
    interbancaria: boolean,
    bancoDestinoId?: number,
  ): void {
    this.botWithdrawalService
      .sendToBot(item.id, interbancaria, bancoDestinoId)
      .subscribe({
        next: () =>
          this._toastrSvc.success(
            `Solicitud #${item.id} enviada al bot${interbancaria ? ' (interbancaria)' : ''}.`,
            'Bot de retiros',
          ),
        error: (error: HttpErrorResponse) =>
          this._toastrSvc.error(
            extractErrorMessage(error, 'es', 'No se pudo enviar la solicitud al bot.'),
            'Bot de retiros',
          ),
      });
  }

  getButtons(item: any) {
    const buttons = [];
    const permissions = REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS;

    switch (item.estado) {
      case REQUEST_STATUS.PENDING:
        if (
          this.hasPermission(
            REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS.CORRECT_REQUEST,
          ) &&
          item.origen !== this.ORIGINS.SORTI_EC
        ) {
          buttons.push(
            this.createButton(
              'Corregir Solicitud',
              'fa-eraser',
              'btn-success',
              () => this.setCorrectionUsed(item),
              item,
            ),
          );
        }
        if (this.hasPermission(permissions.REJECT_REQUEST)) {
          buttons.push(
            this.createButton('Rechazar', 'fa-ban', 'btn-danger', () =>
              this.setState(
                item.id,
                STATE_NAMES.REJECTED,
                this.profile.idusuario,
              ),
            ),
          );
        }
        if (this.hasPermission(permissions.EDIT_REQUEST)) {
          buttons.push(
            this.createButton('Editar', 'fa-pen', 'btn-success', () =>
              this.openEditCw(
                item.id,
                item.estado,
                item.tipo_transaccion,
                item.foto_comprobante,
                item.id_financiero,
                item.updated_by,
              ),
            ),
          );
        }
        if (
          Number(item.tipo_transaccion) === TRANSACTION_TYPE_VALUES.FINANCIAL &&
          this.hasPermission(permissions.SEND_WITHDRAWAL_TO_BOT)
        ) {
          buttons.push(
            this.createButton(
              'Mandar Bot',
              'fa-robot',
              'btn-bot',
              () => this.sendWithdrawalToBot(item),
              item,
            ),
          );
        }
        if (
          [
            TRANSACTION_TYPE_VALUES.LOAD_BONUS_BALANCE,
            TRANSACTION_TYPE_VALUES.PAY_TO_DEBIT,
            TRANSACTION_TYPE_VALUES.FINANCIAL,
            TRANSACTION_TYPE_VALUES.LOAD_RISK_VOUCHER,
            TRANSACTION_TYPE_VALUES.WITHDRAW_RISK_VOUCHER,
          ].includes(item.tipo_transaccion)
        ) {
          if (this.hasPermission(permissions.PREVALIDATED_PROCESSED)) {
            buttons.push(
              this.createButton(
                'Procesado Prevalidado',
                'fa-check-double',
                'btn-success',
                () =>
                  this.setState(
                    item.id,
                    STATE_NAMES.PREVALIDATED_PROCESSED,
                    this.profile.idusuario,
                  ),
              ),
            );
          }
          if (
            [
              TRANSACTION_TYPE_VALUES.LOAD_BONUS_BALANCE,
              TRANSACTION_TYPE_VALUES.PAY_TO_DEBIT,
              TRANSACTION_TYPE_VALUES.LOAD_RISK_VOUCHER,
              TRANSACTION_TYPE_VALUES.WITHDRAW_RISK_VOUCHER,
            ].includes(item.tipo_transaccion) &&
            this.hasPermission(permissions.PROCESSED)
          ) {
            buttons.push(
              this.createButton('Procesado', 'fa-check', 'btn-success', () =>
                this.setState(
                  item.id,
                  STATE_NAMES.PROCESSED,
                  this.profile.idusuario,
                ),
              ),
            );
          }
        } else {
          if (item.solicitud_cruzada === 1) {
            if (this.hasPermission(permissions.PREVALIDATED_PROCESSED)) {
              buttons.push(
                this.createButton(
                  'Procesado Prevalidado',
                  'fa-check-double',
                  'btn-success',
                  () =>
                    this.setState(
                      item.id,
                      STATE_NAMES.PREVALIDATED_PROCESSED,
                      this.profile.idusuario,
                    ),
                ),
              );
            }

            if (this.hasPermission(permissions.PROCESSED)) {
              buttons.push(
                this.createButton('Procesado', 'fa-check', 'btn-success', () =>
                  this.setState(
                    item.id,
                    STATE_NAMES.PROCESSED,
                    this.profile.idusuario,
                  ),
                ),
              );
            }
          } else {
            if (this.hasPermission(permissions.BOT_REQUEST)) {
              buttons.push(
                this.createButton(
                  'Solicitud BOT',
                  'fa-check-double',
                  'btn-success',
                  () =>
                    this.setState(
                      item.id,
                      STATE_NAMES.BOT_REQUEST,
                      this.profile.idusuario,
                    ),
                ),
              );
            }

            if (this.hasPermission(permissions.BOT_REQUEST_PENDING_RECEIPT)) {
              buttons.push(
                this.createButton(
                  'Solicitud BOT (Pendiente Boleta)',
                  'fa-check',
                  'btn-success',
                  () =>
                    this.setState(
                      item.id,
                      STATE_NAMES.BOT_PENDING_SLIP,
                      this.profile.idusuario,
                    ),
                ),
              );
            }
          }
        }
        if (
          item.foto_comprobante &&
          this.hasPermission(permissions.DOWNLOAD_RECEIPT) &&
          item.foto_comprobante !== ''
        ) {
          buttons.push(
            this.createButton(
              'Descargar comprobante',
              'fa-file-image',
              'btn-success',
              () => this.openImageModal(item.id),
            ),
          );
        }
        if (
          ((item.detalle && item.detalle != 'null') || item.id_atc_revisor) &&
          this.hasPermission(permissions.VIEW_DETAILS)
        ) {
          buttons.push(
            this.createButton(
              'Detalles de la Solicitud',
              'fa-info',
              'btn-success',
              () => this.openDetailAlert(item),
            ),
          );
        }
        break;

      case REQUEST_STATUS.BOT_REQUEST:
      case REQUEST_STATUS.BOT_PENDING_RECEIPT:
      case REQUEST_STATUS.BOT_REVERSED:
        if (item.tipo_transaccion === TRANSACTION_TYPE_VALUES.LOAD_BALANCE) {
          if (
            this.hasPermission(
              REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS.DOWNLOAD_RECEIPT,
            ) &&
            item.foto_comprobante !== ''
          ) {
            buttons.push(
              this.createButton(
                'Descargar comprobante',
                'fa-file-image',
                'btn-success',
                () => this.openImageModal(item.id),
              ),
            );
          }
          if (
            this.hasPermission(
              REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS.VIEW_DETAILS,
            )
          ) {
            buttons.push(
              this.createButton(
                'Detalles de la Solicitud',
                'fa-info',
                'btn-success',
                () => this.openDetailAlert(item),
              ),
            );
          }
        } else {
          if (
            ((item.detalle && item.detalle !== 'null') || item.id_atc_revisor) &&
            this.hasPermission(
              REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS.VIEW_DETAILS,
            )
          ) {
            buttons.push(
              this.createButton(
                'Detalles de la Solicitud',
                'fa-info',
                'btn-success',
                () => this.openDetailAlert(item),
              ),
            );
          }
          if (
            item.foto_comprobante &&
            this.hasPermission(
              REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS.DOWNLOAD_RECEIPT,
            ) &&
            item.foto_comprobante !== ''
          ) {
            buttons.push(
              this.createButton(
                'Descargar comprobante',
                'fa-file-image',
                'btn-success',
                () => this.openImageModal(item.id),
              ),
            );
          }
        }

        // Este botón se muestra sin restricción de permisos porque no tiene una acción significativa
        buttons.push(
          this.createButton(
            'Se está encargando el BOT...',
            'fas fa-robot fa-spin',
            'btn-secondary',
            () => {},
          ),
        );
        break;

      case REQUEST_STATUS.PROCESSED:
        if (
          this.hasPermission(REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS.EDIT_REQUEST)
        ) {
          buttons.push(
            this.createButton('Editar', 'fa-pen', 'btn-success', () =>
              this.openEditCw(
                item.id,
                item.estado,
                item.tipo_transaccion,
                item.foto_comprobante,
                item.id_financiero,
                item.updated_by,
              ),
            ),
          );
        }
        if (
          [
            TRANSACTION_TYPE_VALUES.WITHDRAW_BALANCE,
            TRANSACTION_TYPE_VALUES.COLLECT_COMMISSION,
          ].includes(Number(item.tipo_transaccion)) &&
          this.hasPermission(permissions.SEND_WITHDRAWAL_TO_BOT)
        ) {
          buttons.push(
            this.createButton(
              'Mandar Bot',
              'fa-robot',
              'btn-bot',
              () => this.sendWithdrawalToBot(item),
              item,
            ),
          );
        }
        if (
          ![
            TRANSACTION_TYPE_VALUES.CREDIT_DEPOSIT,
            TRANSACTION_TYPE_VALUES.CREDIT_WITHDRAWAL,
          ].includes(item.tipo_transaccion)
        ) {
          if (
            this.hasPermission(
              REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS.CORRECT_REQUEST,
            ) &&
            item.origen !== this.ORIGINS.SORTI_EC
          ) {
            buttons.push(
              this.createButton(
                'Corregir Solicitud',
                'fa-eraser',
                'btn-success',
                () => this.setCorrectionUsed(item),
                item,
              ),
            );
          }
        }
        if (
          this.hasPermission(
            REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS.PREVALIDATED_PROCESSED,
          )
        ) {
          buttons.push(
            this.createButton(
              'Procesado Prevalidado',
              'fa-check-double',
              'btn-success',
              () =>
                this.setState(
                  item.id,
                  STATE_NAMES.PREVALIDATED_PROCESSED,
                  this.profile.idusuario,
                ),
            ),
          );
        }
        if (
          [
            TRANSACTION_TYPE_VALUES.LOAD_BALANCE,
            TRANSACTION_TYPE_VALUES.WITHDRAW_BALANCE,
            TRANSACTION_TYPE_VALUES.LOAD_BONUS_BALANCE,
            TRANSACTION_TYPE_VALUES.PAY_TO_DEBIT,
          ].includes(item.tipo_transaccion) &&
          this.hasPermission(
            REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS.REVERSE_REQUEST,
          ) &&
          item.origen != this.ORIGINS.SORTI_EC &&
          item.playerRemoteId === null
        ) {
          buttons.push(
            this.createButton(
              'Reversar Solicitud',
              'fa-undo-alt',
              'btn-success',
              () => this.openReverseCw(item.id, item.estado, item.id_pais),
            ),
          );
        }
        if (
          [
            TRANSACTION_TYPE_VALUES.WITHDRAW_BALANCE,
            TRANSACTION_TYPE_VALUES.COLLECT_COMMISSION,
            TRANSACTION_TYPE_VALUES.WITHDRAW_RISK_VOUCHER,
          ].includes(item.tipo_transaccion) &&
          this.hasPermission(
            REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS.SPLIT_REQUEST,
          )
        ) {
          if (item.origen !== 1) {
            buttons.push(
              this.createButton(
                'Dividir Solicitud',
                'fa-divide',
                'btn-success',
                () => this.openDivideCw(item.id),
              ),
            );
          }
        }
        if (
          [
            TRANSACTION_TYPE_VALUES.WITHDRAW_BALANCE,
            TRANSACTION_TYPE_VALUES.COLLECT_COMMISSION,
          ].includes(item.tipo_transaccion) &&
          item.id_pais === COUNTRIES.ECUADOR &&
          this.hasPermission(REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS.PAYOUT)
        ) {
          buttons.push(
            this.createButton('Payout', 'fa-dollar-sign', 'btn-success', () =>
              this.openPayOutCw(item.id),
            ),
          );
        }
        if (
          item.foto_comprobante &&
          this.hasPermission(
            REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS.DOWNLOAD_RECEIPT,
          ) &&
          item.foto_comprobante !== ''
        ) {
          buttons.push(
            this.createButton(
              'Descargar comprobante',
              'fa-file-image',
              'btn-success',
              () => this.openImageModal(item.id),
            ),
          );
        }
        if (
          ((item.detalle && item.detalle !== 'null') || item.id_atc_revisor) &&
          this.hasPermission(REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS.VIEW_DETAILS)
        ) {
          buttons.push(
            this.createButton(
              'Detalles de la Solicitud',
              'fa-info',
              'btn-success',
              () => this.openDetailAlert(item),
            ),
          );
        }
        if (item.solicitud_cruzada === 1 && (item.origen === 1 || item.id_remoto)) {
          if (this.hasPermission(permissions.REJECT_REQUEST)) {
            buttons.push(
              this.createButton('Rechazar', 'fa-ban', 'btn-danger', () =>
                this.setState(
                  item.id,
                  STATE_NAMES.REJECTED,
                  this.profile.idusuario,
                ),
              ),
            );
          }
        }
        break;

      case REQUEST_STATUS.PREVALIDATED_PROCESSED:
        if (
          this.hasPermission(REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS.EDIT_REQUEST)
        ) {
          buttons.push(
            this.createButton('Editar', 'fa-pen', 'btn-success', () =>
              this.openEditCw(
                item.id,
                item.estado,
                item.tipo_transaccion,
                item.foto_comprobante,
                item.id_financiero,
                item.updated_by,
              ),
            ),
          );
        }
        if (
          [
            TRANSACTION_TYPE_VALUES.LOAD_BALANCE,
            TRANSACTION_TYPE_VALUES.WITHDRAW_BALANCE,
            TRANSACTION_TYPE_VALUES.LOAD_BONUS_BALANCE,
            TRANSACTION_TYPE_VALUES.PAY_TO_DEBIT,
          ].includes(item.tipo_transaccion) &&
          this.hasPermission(
            REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS.REVERSE_REQUEST,
          ) &&
          item.origen != this.ORIGINS.SORTI_EC &&
          item.playerRemoteId === null
        ) {
          buttons.push(
            this.createButton(
              'Reversar Solicitud',
              'fa-undo-alt',
              'btn-success',
              () => this.openReverseCw(item.id, item.estado, item.id_pais),
            ),
          );
        }
        if (
          [TRANSACTION_TYPE_VALUES.FINANCIAL].includes(item.tipo_transaccion) &&
          this.hasPermission(
            REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS.SPLIT_REQUEST,
          )
        ) {
          buttons.push(
            this.createButton(
              'Dividir Solicitud',
              'fa-divide',
              'btn-success',
              () => this.openDivideCw(item.id),
            ),
          );
        }
        if (
          item.foto_comprobante &&
          this.hasPermission(
            REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS.DOWNLOAD_RECEIPT,
          ) &&
          item.foto_comprobante !== ''
        ) {
          buttons.push(
            this.createButton(
              'Descargar comprobante',
              'fa-file-image',
              'btn-success',
              () => this.openImageModal(item.id),
            ),
          );
        }
        if (
          ((item.detalle && item.detalle !== 'null') || item.id_atc_revisor) &&
          this.hasPermission(REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS.VIEW_DETAILS)
        ) {
          buttons.push(
            this.createButton(
              'Detalles de la Solicitud',
              'fa-info',
              'btn-success',
              () => this.openDetailAlert(item),
            ),
          );
        }
        break;

      case REQUEST_STATUS.VALIDATED_PROCESSED:
        if (
          item.foto_comprobante &&
          this.hasPermission(
            REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS.DOWNLOAD_RECEIPT,
          ) &&
          item.foto_comprobante !== ''
        ) {
          buttons.push(
            this.createButton(
              'Descargar comprobante',
              'fa-file-image',
              'btn-success',
              () => this.openImageModal(item.id),
            ),
          );
        }
        if (
          ((item.detalle && item.detalle !== 'null') || item.id_atc_revisor) &&
          this.hasPermission(REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS.VIEW_DETAILS)
        ) {
          buttons.push(
            this.createButton(
              'Detalles de la Solicitud',
              'fa-info',
              'btn-success',
              () => this.openDetailAlert(item),
            ),
          );
        }
        break;

      case REQUEST_STATUS.NOT_ENTERED:
        if (item.tipo_transaccion === TRANSACTION_TYPE_VALUES.LOAD_BALANCE) {
          if (
            this.hasPermission(
              REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS.BOT_REQUEST,
            )
          ) {
            buttons.push(
              this.createButton(
                'Solicitud BOT',
                'fa-check-double',
                'btn-success',
                () =>
                  this.setState(
                    item.id,
                    STATE_NAMES.BOT_REQUEST,
                    this.profile.idusuario,
                  ),
              ),
            );
          }
          if (
            this.hasPermission(
              REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS.EDIT_REQUEST,
            )
          ) {
            buttons.push(
              this.createButton('Editar', 'fa-pen', 'btn-success', () =>
                this.openEditCw(
                  item.id,
                  item.estado,
                  item.tipo_transaccion,
                  item.foto_comprobante,
                  item.id_financiero,
                  item.updated_by,
                ),
              ),
            );
          }
          if (
            item.foto_comprobante &&
            this.hasPermission(
              REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS.DOWNLOAD_RECEIPT,
            ) &&
            item.foto_comprobante !== ''
          ) {
            buttons.push(
              this.createButton(
                'Descargar comprobante',
                'fa-file-image',
                'btn-success',
                () => this.openImageModal(item.id),
              ),
            );
          }
          if (
            this.hasPermission(
              REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS.CORRECT_REQUEST,
            ) &&
            item.origen !== this.ORIGINS.SORTI_EC
          ) {
            buttons.push(
              this.createButton(
                'Corregir Solicitud',
                'fa-eraser',
                'btn-success',
                () => this.setCorrectionUsed(item),
                item,
              ),
            );
          }
          if (
            ((item.detalle && item.detalle !== 'null') || item.id_atc_revisor) &&
            this.hasPermission(
              REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS.VIEW_DETAILS,
            )
          ) {
            buttons.push(
              this.createButton(
                'Detalles de la Solicitud',
                'fa-info',
                'btn-success',
                () => this.openDetailAlert(item),
              ),
            );
          }
        }
        break;

      case REQUEST_STATUS.DIVIDED:
        if (
          item.foto_comprobante &&
          this.hasPermission(
            REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS.DOWNLOAD_RECEIPT,
          ) &&
          item.foto_comprobante !== ''
        ) {
          buttons.push(
            this.createButton(
              'Descargar comprobante',
              'fa-file-image',
              'btn-success',
              () => this.openImageModal(item.id),
            ),
          );
        }

        if (
          ((item.detalle && item.detalle !== 'null') || item.id_atc_revisor) &&
          this.hasPermission(REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS.VIEW_DETAILS)
        ) {
          buttons.push(
            this.createButton(
              'Detalles de la Solicitud',
              'fa-info',
              'btn-success',
              () => this.openDetailAlert(item),
            ),
          );
        }
        break;

      case REQUEST_STATUS.REJECTED_COMMENT:
      case REQUEST_STATUS.REJECTED:
      case REQUEST_STATUS.REVERSED:
        if (
          item.foto_comprobante &&
          this.hasPermission(
            REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS.DOWNLOAD_RECEIPT,
          ) &&
          item.foto_comprobante !== ''
        ) {
          buttons.push(
            this.createButton(
              'Descargar comprobante',
              'fa-file-image',
              'btn-success',
              () => this.openImageModal(item.id),
            ),
          );
        }

        if (
          ((item.detalle && item.detalle !== 'null') || item.id_atc_revisor) &&
          this.hasPermission(REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS.VIEW_DETAILS)
        ) {
          buttons.push(
            this.createButton(
              'Detalles de la Solicitud',
              'fa-info',
              'btn-success',
              () => this.openDetailAlert(item),
            ),
          );
        }
        break;

      case REQUEST_STATUS.CORRECTION:
        if (
          this.hasPermission(REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS.EDIT_REQUEST)
        ) {
          buttons.push(
            this.createButton('Editar', 'fa-pen', 'btn-success', () =>
              this.openEditCw(
                item.id,
                item.estado,
                item.tipo_transaccion,
                item.foto_comprobante,
                item.id_financiero,
                false,
              ),
            ),
          );
        }
        if (
          item.foto_comprobante &&
          this.hasPermission(
            REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS.DOWNLOAD_RECEIPT,
          ) &&
          item.foto_comprobante !== ''
        ) {
          buttons.push(
            this.createButton(
              'Descargar comprobante',
              'fa-file-image',
              'btn-success',
              () => this.openImageModal(item.id),
            ),
          );
        }
        if (
          this.hasPermission(
            REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS.EDIT_CORRECTION,
          )
        ) {
          buttons.push(
            this.createButton(
              'Editar Corrección',
              'fa-pen',
              'btn-success',
              () =>
                this.openEditCw(
                  item.id,
                  item.estado,
                  item.tipo_transaccion,
                  item.foto_comprobante,
                  item.id_financiero,
                  true,
                ),
            ),
          );
        }
        break;

      case REQUEST_STATUS.BOT_PROBLEM:
        if (
          this.hasPermission(
            REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS.REJECT_REQUEST,
          )
        ) {
          buttons.push(
            this.createButton('Rechazar', 'fa-ban', 'btn-danger', () =>
              this.setState(
                item.id,
                STATE_NAMES.REJECTED,
                this.profile.idusuario,
              ),
            ),
          );
        }

        if (
          this.hasPermission(REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS.BOT_REQUEST)
        ) {
          buttons.push(
            this.createButton(
              'Solicitud BOT',
              'fa-check-double',
              'btn-success',
              () =>
                this.setState(
                  item.id,
                  STATE_NAMES.BOT_REQUEST,
                  this.profile.idusuario,
                ),
            ),
          );
        }

        if (
          this.hasPermission(
            REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS.BOT_REQUEST_PENDING_RECEIPT,
          )
        ) {
          buttons.push(
            this.createButton(
              'Solicitud BOT (Pendiente Boleta)',
              'fa-check',
              'btn-success',
              () =>
                this.setState(
                  item.id,
                  STATE_NAMES.BOT_PENDING_SLIP,
                  this.profile.idusuario,
                ),
            ),
          );
        }

        if (
          this.hasPermission(REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS.EDIT_REQUEST)
        ) {
          buttons.push(
            this.createButton('Editar', 'fa-pen', 'btn-success', () =>
              this.openEditCw(
                item.id,
                item.estado,
                item.tipo_transaccion,
                item.foto_comprobante,
                item.id_financiero,
                item.updated_by,
              ),
            ),
          );
        }
        if (
          item.foto_comprobante &&
          this.hasPermission(
            REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS.DOWNLOAD_RECEIPT,
          ) &&
          item.foto_comprobante !== ''
        ) {
          buttons.push(
            this.createButton(
              'Descargar comprobante',
              'fa-file-image',
              'btn-success',
              () => this.openImageModal(item.id),
            ),
          );
        }
        if (
          ((item.detalle && item.detalle !== 'null') || item.id_atc_revisor) &&
          this.hasPermission(REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS.VIEW_DETAILS)
        ) {
          buttons.push(
            this.createButton(
              'Detalles de la Solicitud',
              'fa-info',
              'btn-success',
              () => this.openDetailAlert(item),
            ),
          );
        }
        break;

      case REQUEST_STATUS.EN_REVISION:
        if (this.hasPermission(REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS.ATC_REVIEW_ACTION)) {
          buttons.push(
            this.createButton(
              'Revisar ATC',
              'fa-hand-holding-dollar',
              'btn-warning',
              () =>
                this.setState(
                  item.id,
                  STATE_NAMES.PROCESSED,
                  this.profile.idusuario,
                ),
            ),
          );
          buttons.push(
            this.createButton('Rechazar', 'fa-ban', 'btn-danger', () =>
              this.setState(
                item.id,
                STATE_NAMES.REJECTED,
                this.profile.idusuario,
              ),
            ),
          );
        }
        if (this.hasPermission(REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS.VIEW_DETAILS)) {
          buttons.push(
            this.createButton(
              'Detalles de la Solicitud',
              'fa-info',
              'btn-success',
              () => this.openDetailAlert(item),
            ),
          );
        }
        break;
    }

    return buttons;
  }

  setCorrectionUsed(item: any) {
    this.setStateWithCorrection(
      item.id,
      STATE_NAMES.CORRECTION,
      this.profile.idusuario,
      () => {
        this.correctionUsed[item.id] = true;
      },
    );
  }

  setStateWithCorrection(
    id: number,
    newState: number,
    idusuarioSet: number,
    callback: () => void,
  ) {
    this.alertService
      .showConfirmAlert(
        '¿Estás seguro?',
        'No podrás revertir esto!',
        'Sí, cambiar estado!',
        'Cancelar',
      )
      .then((result) => {
        if (result.isConfirmed) {
          this.handleStateChange(id, newState, idusuarioSet, callback);
        }
      });
  }

  handleStateChange(
    id: number,
    newState: number,
    idusuarioSet: number,
    callback: () => void,
  ) {
    const stateActions: {
      [key: number]: (
        id: number,
        newState: number,
        idusuarioSet: number,
        callback: () => void,
      ) => void;
    } = {
      [STATE_NAMES.REJECTED]: this.promptForReason.bind(this),
      [STATE_NAMES.CORRECTION]: this.promptForReason.bind(this),
    };

    const action = stateActions[newState] || this.defaultStateChange.bind(this);

    action(id, newState, idusuarioSet, callback);
  }

  promptForReason(
    id: number,
    newState: number,
    idusuarioSet: number,
    callback: () => void,
  ) {
    const title =
      newState === STATE_NAMES.REJECTED
        ? 'Escribe el motivo del rechazo'
        : 'Escribe el motivo de la corrección';

    this.alertService
      .showInputAlert(
        title,
        'Motivo',
        'Escribe aquí...',
        'Enviar motivo',
        'Cancelar',
      )
      .then((textResult) => {
        if (textResult.isConfirmed && textResult.value) {
          this.updateStateWithReason(
            id,
            newState,
            idusuarioSet,
            textResult.value,
          );
          callback();
        }
      });
  }

  defaultStateChange(
    id: number,
    newState: number,
    idusuarioSet: number,
    callback: () => void,
  ) {
    this.updateState(id, newState, idusuarioSet);
    callback();
  }

  hasCorrectionOrEditButton(item: any): boolean {
    const buttons = this.getButtons(item);
    return buttons.some(
      (button) =>
        button.tooltip === 'Corregir Solicitud' ||
        button.tooltip === 'Editar' ||
        button.tooltip === 'Editar Corrección',
    );
  }

  //* CARD
  showMenu: boolean = false;
  showSubMenu: boolean = false;
  actualRow: FormattedCwItem | null = null;
  toggleMenu(index: number, item: any) {
    this.showMenu = !this.showMenu;
    if (this.showMenu) {
      this.actualIndex = index;
      this.actualItemClient = this.convertObjectToArray({
        Identificación: item.identificacion,
        'Nombre Titular': item.nombre_titular,
        Beneficiario: item.formatted_name,
        'Número de Cuenta': item.numero_cuenta,
        Banco: item.bank,
      });
      this.actualItemEnterprise = this.convertObjectToArray({
        Banco: item.bank_enterprise,
        'Titular Bancario': item.formatted_holder_name,
      });

      this.actualRow = item;
      this.buttons = this.getButtons(item);

      document.body.style.overflowY = 'hidden';
    } else {
      document.body.style.overflowY = 'auto';
    }
  }

  convertObjectToArray(obj: any): { key: string; value: any }[] {
    return Object.keys(obj)
      .filter((key) => obj[key] !== 'null')
      .map((key) => ({ key: key, value: obj[key] }));
  }

  expandCard(index: number) {
    this.cardExpanded[index] = !this.cardExpanded[index];
  }

  closeMenu() {
    this.showMenu = false;
    this.showSubMenu = false;
    document.body.style.overflowY = 'auto';
  }

  openSubMenu(itemType: string) {
    this.itemType = itemType;
    if (itemType === 'client') {
      this.actualItem = this.actualItemClient;
    } else if (itemType === 'enterprise') {
      this.actualItem = this.actualItemEnterprise;
    }
    this.showSubMenu = true;
  }

  closeSubMenu() {
    this.showMenu = true;
    this.showSubMenu = false;
  }

  // OTHERS

  exportToExcel() {
    const dataToExport = this.cwData.map((item: any) => ({
      satus: this.getStateClasses(item.estado).text.replace(/<br>/g, ' '),
      amount: item.monto,
      transactionType: this.transactionTypes[item.tipo_transaccion].label,
      created: moment(item.creado).format('DD/MM/YYYY HH:mm:ss'),
      client:
        item.agent || item.jugador || item.accounting_account.nombre_cuenta,
      receipt: item.comprobante,
      enterpriseReceipt: item.comprobante_empresa,
      repeat_receipt: item.permitir_comprobante_repetido === 1 ? 'Si' : 'No',
      holder: item.holder,
      beneficiary:
        item.nombre_titular && item.nombre_titular !== 'null'
          ? item.nombre_titular
          : '',
      clientBank: item.bank,
      identifiaction:
        item.identificacion && item.identificacion !== 'null'
          ? item.identificacion
          : '',
      accountNumber:
        item.numero_cuenta && item.numero_cuenta !== 'null'
          ? item.numero_cuenta
          : '',
      enterpriseBank: item.bank_enterprise,
      updated: moment(item.actualizado).format('DD/MM/YYYY HH:mm:ss'),
    }));

    this.excelExportService.exportToExcel(
      dataToExport,
      'solicitud_CR',
      headersExcel,
    );
  }
}
